import {
  Attribute,
  GetUserAttributesRequest,
} from "@safetyculture/s12-apis-connect-web/s12/users/userattribute/v1/attribute_pb";
import {
  Field,
  ListFieldsRequest,
} from "@safetyculture/s12-apis-connect-web/s12/users/userfield/v1/field_pb";

import { toUUID } from "../../helpers/s12-helpers";
import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "../types";

export const listFields = async (
  { orgId, filter }: ListFieldsRequest,
  headers: Record<RequestMetadata, string>,
): Promise<Field[] | undefined> => {
  const orgUUID = toUUID(orgId);
  const req = new ListFieldsRequest({
    orgId: orgUUID,
    filter,
  });

  return supportServiceConnectClient
    .listFields(req, { headers })
    .then((res) => res.fields);
};

export const getUserAttributes = async (
  { orgId, userId }: GetUserAttributesRequest,
  headers: Record<RequestMetadata, string>,
): Promise<Attribute[] | undefined> => {
  const orgUUID = toUUID(orgId);
  const userIdUUID = toUUID(userId);
  const req = new GetUserAttributesRequest({
    orgId: orgUUID,
    userId: userIdUUID,
  });

  return supportServiceConnectClient
    .getUserAttributes(req, { headers })
    .then((res) => res.attributes);
};
